var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notification.dataList && _vm.notification.dataList.length
    ? _c(
        "div",
        { staticClass: "news-set" },
        [
          _c("a-dropdown", { attrs: { placement: "bottomRight" } }, [
            _c(
              "div",
              [
                _c(
                  "a-badge",
                  {
                    attrs: {
                      count: _vm.notification.noReadCount,
                      "overflow-count": _vm.maxCount,
                      offset: [
                        ((
                          "" +
                          (_vm.notification.noReadCount > _vm.maxCount
                            ? _vm.maxCount + 1
                            : _vm.notification.noReadCount)
                        ).length -
                          1) *
                          2,
                        0
                      ],
                      "number-style": {
                        height: "16px",
                        lineHeight: "16px",
                        fontSize: "12px",
                        padding: "0 5px",
                        boxShadow: "0 0 0 1px transparent"
                      }
                    }
                  },
                  [
                    _c("icon-font", {
                      staticClass: "icon",
                      attrs: { type: "gb-icon-notice" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "news-menu",
                attrs: { slot: "overlay" },
                slot: "overlay"
              },
              [
                _c("div", { staticClass: "news-menu-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.langCodeLabels[_vm.currentLang].title) +
                      " "
                  )
                ]),
                _vm._l(_vm.notification.dataList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "news-menu-item",
                      on: {
                        click: function($event) {
                          return _vm.toDetails(item)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "news-menu-item-top" }, [
                        _vm.msgTypeList[item.msgType]
                          ? _c(
                              "div",
                              { staticClass: "news-menu-item-top__label" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.msgTypeList[item.msgType][
                                      _vm.langCodes[_vm.currentLang]
                                    ]
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "news-menu-item-top__time" },
                          [
                            _c("a-icon", {
                              staticStyle: {
                                "margin-right": "3px",
                                "font-size": "12px",
                                color: "#444444"
                              },
                              attrs: { type: "clock-circle" }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(item.sendTime || item.createTime)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                ) +
                                " "
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "news-menu-item-info",
                          attrs: { title: item.msgTitle }
                        },
                        [_vm._v(" " + _vm._s(item.msgTitle) + " ")]
                      )
                    ]
                  )
                }),
                _c(
                  "div",
                  { staticClass: "news-menu-more" },
                  [
                    _c(
                      "a-button",
                      {
                        staticStyle: { "font-size": "12px" },
                        attrs: { type: "link" },
                        on: {
                          click: function($event) {
                            return _vm.toDetails()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.langCodeLabels[_vm.currentLang].more) +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              2
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }